import { get } from "svelte/store";
import { loadCampaign, validateAndUpdateCampaign } from "./helpers/campaign";
import { loadMicrositeSettings } from "./helpers/config";
import { settingsStore } from "./stores/settings";
import { type Route, updateSession } from "./stores/session";
import type { FoojiData } from "../types/campaign";
import { getSearchParam, removeSearchParam } from "./helpers/document";
import { isTestMode } from "./stores/mode";
import { handleTempJWTIfPresent } from "./helpers/jwtExchanger";

const persistFoojiData = (rawData: string) => {
  try {
    const foojiData = JSON.parse(atob(rawData)) as FoojiData;
    console.log("Persisting fooji data", foojiData);
    updateSession({ foojiData });
  } catch (e) {
    console.error("Error decoding fooji data", e);
    return;
  }
};

export const processFoojiData = () => {
  const foojiData = getSearchParam("data");
  if (!foojiData) return;

  console.log("Processing fooji data", foojiData);
  persistFoojiData(foojiData);
  removeSearchParam("data");
};

export const isUserBrowserCompatible = () => {
  if (typeof Intl?.DisplayNames === "undefined") {
    return false;
  }
  return true;
};

export const initMicrosite = async () => {
  processFoojiData();
  await loadMicrositeSettings();
  const settings = get(settingsStore);
  const campaignKey = settings.campaign as string;

  if (isTestMode()) {
    await loadCampaign(campaignKey);
  } else {
    await Promise.all([loadCampaign(campaignKey), validateAndUpdateCampaign(campaignKey)]);
  }

  if (!settings.requiresCaptcha) {
    await handleTempJWTIfPresent();
  }

  const loadedRoutes = settings.v2 as {
    flow: Route[];
  };

  updateSession({ routes: loadedRoutes.flow });
};
